export default __webpack_public_path__ + "static/media/logo-jira.66aec637.svg";